/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime'
import type {
  GetAddressSuggest401Response,
  GetAddressSuggest403Response,
  GetCountries200Response,
  GetCountry200Response,
  GetCountry404Response,
  GetCountrySubjects200Response,
} from '../models/index'
import {
  GetAddressSuggest401ResponseFromJSON,
  GetAddressSuggest401ResponseToJSON,
  GetAddressSuggest403ResponseFromJSON,
  GetAddressSuggest403ResponseToJSON,
  GetCountries200ResponseFromJSON,
  GetCountries200ResponseToJSON,
  GetCountry200ResponseFromJSON,
  GetCountry200ResponseToJSON,
  GetCountry404ResponseFromJSON,
  GetCountry404ResponseToJSON,
  GetCountrySubjects200ResponseFromJSON,
  GetCountrySubjects200ResponseToJSON,
} from '../models/index'

export interface GetCountryRequest {
  country: string
}

export interface GetCountrySubjectsRequest {
  country?: string
}

/**
 * DictionaryApi - interface
 *
 * @export
 * @interface DictionaryApiInterface
 */
export interface DictionaryApiInterface {
  /**
   * Список стран справочника (uuid, название, ISO-код). Требуется подтверждённый email.
   * @summary Получить список стран
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DictionaryApiInterface
   */
  getCountriesRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetCountries200Response>>

  /**
   * Список стран справочника (uuid, название, ISO-код). Требуется подтверждённый email.
   * Получить список стран
   */
  getCountries(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetCountries200Response>

  /**
   * Поиск страны по ISO-коду, русскому или английскому названию. В data.country — полная модель страны (в отличие от списка /countries включает nameEng и таймстемпы). Требуется подтверждённый email.
   * @summary Получить страну по коду или названию
   * @param {string} country ISO-код (RU), русское (Россия) или английское (Russia) название страны
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DictionaryApiInterface
   */
  getCountryRaw(
    requestParameters: GetCountryRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetCountry200Response>>

  /**
   * Поиск страны по ISO-коду, русскому или английскому названию. В data.country — полная модель страны (в отличие от списка /countries включает nameEng и таймстемпы). Требуется подтверждённый email.
   * Получить страну по коду или названию
   */
  getCountry(
    requestParameters: GetCountryRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetCountry200Response>

  /**
   * Список субъектов страны (для RU — регионы Российской Федерации). Страна определяется по ISO-коду из query-параметра. Требуется подтверждённый email.
   * @summary Получить список субъектов страны
   * @param {string} [country] ISO-код страны, существующей в справочнике (по умолчанию RU)
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DictionaryApiInterface
   */
  getCountrySubjectsRaw(
    requestParameters: GetCountrySubjectsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetCountrySubjects200Response>>

  /**
   * Список субъектов страны (для RU — регионы Российской Федерации). Страна определяется по ISO-коду из query-параметра. Требуется подтверждённый email.
   * Получить список субъектов страны
   */
  getCountrySubjects(
    requestParameters: GetCountrySubjectsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetCountrySubjects200Response>
}

/**
 *
 */
export class DictionaryApi
  extends runtime.BaseAPI
  implements DictionaryApiInterface
{
  /**
   * Список стран справочника (uuid, название, ISO-код). Требуется подтверждённый email.
   * Получить список стран
   */
  async getCountriesRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetCountries200Response>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/dictionary/countries`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetCountries200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Список стран справочника (uuid, название, ISO-код). Требуется подтверждённый email.
   * Получить список стран
   */
  async getCountries(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetCountries200Response> {
    const response = await this.getCountriesRaw(initOverrides)
    return await response.value()
  }

  /**
   * Поиск страны по ISO-коду, русскому или английскому названию. В data.country — полная модель страны (в отличие от списка /countries включает nameEng и таймстемпы). Требуется подтверждённый email.
   * Получить страну по коду или названию
   */
  async getCountryRaw(
    requestParameters: GetCountryRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetCountry200Response>> {
    if (requestParameters['country'] == null) {
      throw new runtime.RequiredError(
        'country',
        'Required parameter "country" was null or undefined when calling getCountry().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/dictionary/country/{country}`.replace(
          `{${'country'}}`,
          encodeURIComponent(String(requestParameters['country']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetCountry200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Поиск страны по ISO-коду, русскому или английскому названию. В data.country — полная модель страны (в отличие от списка /countries включает nameEng и таймстемпы). Требуется подтверждённый email.
   * Получить страну по коду или названию
   */
  async getCountry(
    requestParameters: GetCountryRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetCountry200Response> {
    const response = await this.getCountryRaw(requestParameters, initOverrides)
    return await response.value()
  }

  /**
   * Список субъектов страны (для RU — регионы Российской Федерации). Страна определяется по ISO-коду из query-параметра. Требуется подтверждённый email.
   * Получить список субъектов страны
   */
  async getCountrySubjectsRaw(
    requestParameters: GetCountrySubjectsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetCountrySubjects200Response>> {
    const queryParameters: any = {}

    if (requestParameters['country'] != null) {
      queryParameters['country'] = requestParameters['country']
    }

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/dictionary/country/subjects`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetCountrySubjects200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Список субъектов страны (для RU — регионы Российской Федерации). Страна определяется по ISO-коду из query-параметра. Требуется подтверждённый email.
   * Получить список субъектов страны
   */
  async getCountrySubjects(
    requestParameters: GetCountrySubjectsRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetCountrySubjects200Response> {
    const response = await this.getCountrySubjectsRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }
}
